import styled from 'styled-components';

import { DESKTOP_BACKGROUND_SIZE } from './constants';
import { Wrapper as DefaultWrapper } from './loyalty-background.styled.default';

export * from './loyalty-background.styled.default';

export const Wrapper = styled(DefaultWrapper)`
  background-image: ${p => (p.$withBackground ? `url(${p.$bgImage})` : 'none')};
  background-color: inherit;
  ${Styles.desktop} {
    background-size: ${DESKTOP_BACKGROUND_SIZE};
  }
`;
